module.exports = __webpack_public_path__ + "static/media/house-boat.24af8396.jpg";